<template>
  <div class="carousel-components">
    <div class="carousel">
      <hooper :progress="true" :autoPlay="true" :playSpeed="4500" :wheelControl="false" :mouseDrag="false" :infiniteScroll="true" :hoverPause="false">
        <slide>
          <img src="../../assets/img/home/slider/image01.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image02.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image03.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image04.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image05.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image06.png" alt="">
        </slide>
        <slide>
          <img src="../../assets/img/home/slider/image07.png" alt="">
        </slide>
      </hooper>
    </div>
  </div>
</template>
<script>
import { Hooper, Slide } from 'hooper';
import '@/assets/css/hooper.css';
export default {
  name: 'Carousel',
  components: {
    Hooper,
    Slide,
  }
}
</script>
<style scoped lang="scss">
.carousel {
  width: 100%;
  height: auto;
  position: relative;
  margin: 0 auto;
  max-width: 1300px;
}
.hooper {
  height: auto;
}
</style>